<div class="custom-select-container" [class.open]="isOpen" (click)="toggleDropdown()">
  <div
    class="custom-select-trigger"
    [style.background-color]="backgroundColor">
    <div class="selected-content">
      @if (showIcon && getSelectedOption()?.icon) {
        <span
          class="selected-icon"
          [innerHTML]="getSelectedOption()?.icon">
        </span>
      }
      <span class="selected-text" [style.color]="textColor">{{ getSelectedText() }}</span>
    </div>
    <span class="arrow" [class.rotated]="isOpen" [style.color]="arrowColor">▼</span>
  </div>
  @if (isOpen) {
    <div class="custom-select-dropdown">
      @for (option of options; track option.value) {
        <div
          class="custom-select-option"
          [class.selected]="option.value === selectedValue"
          (click)="selectOption(option, $event)">
          @if (showIcon && option.icon) {
            <span
              class="option-icon"
              [innerHTML]="option.icon">
            </span>
          }
          <span class="option-text">{{ option.label }}</span>
        </div>
      }
    </div>
  }
</div>
@if (isOpen) {
  <div class="backdrop" (click)="closeDropdown()"></div>
}
